import {z} from 'zod';

import {getCourseDocumentPath} from './course';

// ============================================================================
// Path segments
// ============================================================================

export const PRERECORDED_SECTIONS_SUBCOLLECTION =
  'prerecordedSections' as const;
export const PRERECORDED_VIDEO_LINKS_DOCUMENT_ID = 'videoLinks' as const;
export const PRERECORDED_CONFIG_DOCUMENT_ID = 'config' as const;

// ============================================================================
// Schemas
// ============================================================================

/**
 * Map of week number (as string key) to YouTube (or other) video URL.
 */
export const PrerecordedVideosDocumentSchema = z.record(z.string(), z.string());

export type PrerecordedVideosDocument = z.infer<
  typeof PrerecordedVideosDocumentSchema
>;

/** Config document for pre-recorded sections (student-facing toggle). */
export const PrerecordedConfigDocumentSchema = z
  .object({
    /** Whether the pre-recorded sections entry point is visible to students. */
    enabled: z.boolean().optional(),
  })
  .loose();

export type PrerecordedConfigDocument = z.infer<
  typeof PrerecordedConfigDocumentSchema
>;

// ============================================================================
// Paths
// ============================================================================

export function getPrerecordedVideoLinksDocumentPath({
  courseId,
}: {
  courseId: string;
}): string {
  return `${getCourseDocumentPath({courseId})}/${PRERECORDED_SECTIONS_SUBCOLLECTION}/${PRERECORDED_VIDEO_LINKS_DOCUMENT_ID}`;
}

export function getPrerecordedConfigDocumentPath({
  courseId,
}: {
  courseId: string;
}): string {
  return `${getCourseDocumentPath({courseId})}/${PRERECORDED_SECTIONS_SUBCOLLECTION}/${PRERECORDED_CONFIG_DOCUMENT_ID}`;
}
